import { createContext, useEffect, useState } from "react";
import api from "../../service/api";

export const UserContext = createContext(null);

export const UserContextProvider = ({children}) => {
  const [user, setUser] = useState({});
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const brokerToken = localStorage.getItem('broker_token');
  
      if(brokerToken){
        try {
          const {data} = await api.get('accounts/profile');
          if (data){
            setLoggedIn(true);
            setUser({
              id: data.id,
              name: data.name
            });
          }
        } catch {
          localStorage.removeItem('broker_token');
        }
      }
  
      setLoading(false);
    }

    fetchData()
  }, []);

  return (
    <UserContext.Provider value={{user, setUser, isLoggedIn, setLoggedIn, loading}}>
      {children}
    </UserContext.Provider>
  )
}